var _defs, _path, _path2, _path3, _path4, _polygon, _path5, _polygon2, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoTmp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 394.44 84.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#feb325;}.cls-1,.cls-2,.cls-3{fill-rule:evenodd;}.cls-2{fill:#7d4199;}.cls-3{fill:#c1d82f;}.cls-4{fill:#b30838;}.cls-5{fill:#363636;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M171.49,28.38a15.92,15.92,0,0,0,27.17-11.9c-.25-6.3-1.44-10,1.24-16.48-6.44,2.65-10.17,1.51-16.42,1.22a15.92,15.92,0,0,0-12,27.16"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M157.21,4.65a15.92,15.92,0,0,1-11.9,27.17c-6.3-.25-10-1.44-16.49,1.23,2.65-6.44,1.51-10.16,1.23-16.42a15.92,15.92,0,0,1,27.16-12"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M120.63,28.38a15.92,15.92,0,0,1-27.17-11.9c.25-6.3,1.44-10-1.23-16.48,6.43,2.65,10.16,1.51,16.42,1.22a15.92,15.92,0,0,1,12,27.16"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M61.29,4.65A15.92,15.92,0,0,0,73.18,31.82c6.3-.25,10-1.44,16.48,1.23C87,26.61,88.15,22.89,88.44,16.63a15.91,15.91,0,0,0-27.15-12"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "89.65 52.83 89.65 59.33 89.65 69.05 81.9 69.05 81.9 43.16 89.65 43.16 89.65 52.83"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M351.84,69h-7.78V43.16h7.78l23.26.05a6.67,6.67,0,0,1,5,1.71,13.4,13.4,0,0,1,2.33,2.86l10,21.26h-8.18l-8.53-16.36a9.28,9.28,0,0,0-1.88-1.9,5,5,0,0,0-3.28-1.13H351.84V69Zm15.52,0h-7.78V52.86h7.78Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "128.75 43.16 128.75 59.6 105.48 43.16 105.47 43.16 105.47 43.16 97.75 43.16 97.75 69.05 105.47 69.05 105.47 52.62 128.75 69.05 136.48 69.05 136.48 43.16 128.75 43.16"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M44.91,43.16v6.49H67.56v3.92a3.31,3.31,0,0,1-1,1.64,3.71,3.71,0,0,1-2.31.76c-1,.06-1.94.09-2.71.09h-14v6.51h9.56l6,6.48h8.81l-6-6.5a10.45,10.45,0,0,0,6.27-3,8.65,8.65,0,0,0,3.16-5.69V43.16Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M307,43.16v6.49h22.65v3.92a3.37,3.37,0,0,1-1,1.64,3.71,3.71,0,0,1-2.31.76c-1,.06-1.95.09-2.72.09h-14v6.51h9.56l6,6.48h8.8l-6-6.5a10.45,10.45,0,0,0,6.28-3,8.59,8.59,0,0,0,3.15-5.69V43.16Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M180.93,49.65v-.12l-.08.12Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M180.85,43.16H142.2v6.49h12v19.4h7.73V49.65H176a18.78,18.78,0,0,1,1-2,16.69,16.69,0,0,1,3.82-4.48"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M179.29,58.64V69.05h9V62.57h21.9v6.48H218V43.16H192.72s-13.43.3-13.43,15.48m11-7.5q2-1.43,6.65-1.42H210.1v6.33H188.29c0-2.37.69-4,2-4.91"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M30,55.21A3.8,3.8,0,0,1,27.7,56c-1,.06-1.94.08-2.71.08H11v6.52H27.73a11.05,11.05,0,0,0,11-11.07V43.16H0V69H7.78V49.65H31v3.91a3.35,3.35,0,0,1-1,1.65"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M258.84,49.65a17.11,17.11,0,0,1,1-2,16.34,16.34,0,0,1,3.82-4.48H232a7,7,0,0,0-6.85,7.07V69.05h8.41v-4a2.52,2.52,0,0,1,2.74-2.47h10.27V56.07H232.44V52.71a3,3,0,0,1,3-3h23.36Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M275.93,43.16a15.28,15.28,0,0,0-4.08.83l-.3.12-.21.07-1,.45c-3.68,1.75-7.8,5.59-7.8,14V69h24.11a18.16,18.16,0,0,0,9-2.87c2.9-2.15,5.5-6.12,5.5-12.78V43.16Zm16.18,12.41c0,2.59-.67,4.54-2,5.49s-3.58,1.42-6.65,1.42H271.55v-6.2c0-2.61.68-4.37,2-5.32s3.57-1.42,6.65-1.42h11.87Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M234.91,75.85a2.34,2.34,0,0,1,2.66,2.39c0,1.31-.88,2.34-2.82,2.34h-1.24v3.61h-1.2V75.85Zm-1.4,3.65h1.35c.9,0,1.47-.47,1.47-1.31a1.23,1.23,0,0,0-1.42-1.27h-1.4Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M241.65,75.85c1.69,0,2.75.89,2.75,2.33a2.11,2.11,0,0,1-1.4,2,6.59,6.59,0,0,1,1.85,2.31c.36.57.57.85,1.14,1.65h-1.43l-1.1-1.71c-1.1-1.72-1.6-1.91-2.21-1.91h-.5v3.62h-1.2V75.85Zm-.9,3.64h.77c1.29,0,1.65-.66,1.64-1.35s-.48-1.27-1.64-1.27h-.77Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M249,84.19h-1.2V75.85H249Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M259.51,84.19h-1l-5.57-6.43v6.43h-1.13V75.85h.95l5.65,6.45V75.85h1.13Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M268.52,76.92h-2.88v7.27h-1.2V76.92h-2.89V75.85h7Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M281.21,80a7.08,7.08,0,0,1-1.35,2.19l1.68,2H280l-.95-1.13a4,4,0,0,1-2.65,1.24,2,2,0,0,1-2.1-2c0-1,.81-1.79,2-2.46a3,3,0,0,1-.95-1.94A1.92,1.92,0,0,1,277.46,76a1.87,1.87,0,0,1,2,1.82c0,.8-.45,1.46-1.53,2.22l1.18,1.35A5.1,5.1,0,0,0,280,80Zm-4.26.62c-.93.58-1.46,1-1.46,1.66a1,1,0,0,0,1,.88,2.73,2.73,0,0,0,1.79-1Zm.32-1.42c.89-.57,1.09-.93,1.09-1.36a.88.88,0,0,0-.95-.85.83.83,0,0,0-.91.79A2.29,2.29,0,0,0,277.27,79.24Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M295.51,84.19H294.3v-6.5h0l-2.57,3.23h-.19L289,77.69h0v6.5h-1.21V75.85h1.13l2.77,3.43,2.77-3.43h1.12Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M305.46,84.19h-1.22l-1.11-2.46h-3.55l-1.05,2.46h-1.22l3.58-8.39h.84ZM300,80.66h2.6l-1.35-3Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M308.51,84.19h-1.2V75.85h1.2Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M312.44,83.11h3.78v1.08h-5V75.85h1.19Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M326.44,77.68a2.81,2.81,0,0,0-2-.87c-.77,0-1.32.41-1.32,1,0,1.61,3.61,1.58,3.61,4.24a2.23,2.23,0,0,1-2.33,2.26,3.77,3.77,0,0,1-2.35-.77V82a2.83,2.83,0,0,0,2.21,1.22c.93,0,1.36-.59,1.36-1.06,0-1.72-3.61-1.92-3.61-4.2a2.25,2.25,0,0,1,2.53-2.23,3.31,3.31,0,0,1,1.86.58Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M333.1,75.74A4.28,4.28,0,1,1,328.61,80,4.25,4.25,0,0,1,333.1,75.74Zm0,7.46A3.19,3.19,0,1,0,329.85,80,3.13,3.13,0,0,0,333.1,83.2Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M341.14,75.85h-1.2v8.34h5V83.11h-3.77Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M353.87,80.91c0,2-1.23,3.39-3.71,3.39A3.18,3.18,0,0,1,346.68,81V75.85h1.2v4.92c0,.94.12,1.34.5,1.72a2.47,2.47,0,0,0,1.8.71,2.69,2.69,0,0,0,2-.68,2.39,2.39,0,0,0,.53-1.81V75.85h1.2Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M362.68,76.92H359.8v7.27h-1.2V76.92h-2.89V75.85h7Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M365.93,75.85h-1.21v8.34h1.21Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M372.79,75.74A4.28,4.28,0,1,1,368.31,80,4.24,4.24,0,0,1,372.79,75.74Zm0,7.46A3.19,3.19,0,1,0,369.54,80,3.14,3.14,0,0,0,372.79,83.2Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M387.39,84.19h-1l-5.59-6.43v6.43h-1.12V75.85h.95l5.66,6.45V75.85h1.12Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M394.1,77.68a2.79,2.79,0,0,0-2-.87c-.77,0-1.32.41-1.32,1,0,1.61,3.61,1.58,3.61,4.24a2.23,2.23,0,0,1-2.34,2.26,3.72,3.72,0,0,1-2.34-.77V82A2.8,2.8,0,0,0,392,83.23c.92,0,1.35-.59,1.35-1.06,0-1.72-3.6-1.92-3.6-4.2a2.24,2.24,0,0,1,2.53-2.23,3.31,3.31,0,0,1,1.85.58Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTmp);
export default __webpack_public_path__ + "static/media/logo_tmp.07362383.svg";
export { ForwardRef as ReactComponent };